var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-back",attrs:{"to":{ name: _vm.game },"id":"pad-back","pad-up":"go:#pad-home","pad-left":"go:.swiper-slide-active a","pad-a":"click"}},[_c('iconArrowBack')],1)}
var staticRenderFns = []

export { render, staticRenderFns }